import React from 'react';
import { ILxsCreateOrderResources } from '../lxs-create-order.props.autogenerated';
import { DebouncedInput } from './debounced-input';
import Dropdown from './dropdown';
import { ColumnFiltersState } from '@tanstack/react-table';
import Alert from '../../../components/alert';
import { CREATE_ORDER_COLUMN_INCOTERM, CREATE_ORDER_COLUMN_SALES_ORG, CREATE_ORDER_COLUMN_BUSINESS_UNIT } from '../../../configuration';

export default function({
    globalFilter,
    resources,
    salesOrgOptions,
    businessUnitOptions,
    columnFilters,
    isColumnFilterValid,
    incotermOptions,
    filterDisabled,
    setColumnFilters,
    setGlobalFilter
}: {
    globalFilter: string;
    resources: ILxsCreateOrderResources;
    salesOrgOptions?: { value: string; label: string }[];
    businessUnitOptions?: { value: string; label: string }[];
    incotermOptions?: { value: string; label: string }[];
    columnFilters: ColumnFiltersState;
    isColumnFilterValid: boolean;
    filterDisabled: boolean;
    setGlobalFilter: React.Dispatch<React.SetStateAction<string>>;
    setColumnFilters: React.Dispatch<React.SetStateAction<ColumnFiltersState>>;
}) {
    const [alertVisible, setAlertVisible] = React.useState<boolean>(true);
    return (
        <div className='msc-section-box pb-0'>
            <h4 className='msc-section-box__title lxs-create-order__search-title sr-only'>{resources.createOrderSearchHeading}</h4>
            <div className='row'>
                <div className='col-12'>
                    <fieldset className='msc-form__group'>
                        <label htmlFor='search-soldtos'>{resources.createOrderSearchLabel}</label>
                        <DebouncedInput
                            type='search'
                            value={globalFilter ?? ''}
                            onChange={(value: string) => setGlobalFilter(value)}
                            placeholder={resources.createOrderSearchPlaceholder}
                            resources={resources}
                            id='search-soldtos'
                        />
                    </fieldset>
                </div>
            </div>

            <h4 className='msc-section-box__title lxs-create-order__filter-title sr-only'>{resources.createOrderFilterHeading}</h4>
            <div className='row'>
                <div className='col-12 col-lg-4'>
                    <fieldset className='msc-form__group'>
                        <Dropdown
                            disabled={filterDisabled}
                            id={CREATE_ORDER_COLUMN_SALES_ORG}
                            value={(columnFilters.find(filter => filter.id === CREATE_ORDER_COLUMN_SALES_ORG)?.value as string) ?? ''}
                            options={salesOrgOptions}
                            resources={resources}
                            onChange={(salesOrg: string) =>
                                setColumnFilters(prev => {
                                    const currentFilters = prev.slice();
                                    const salesOrgFilter = currentFilters.find(filter => filter.id === CREATE_ORDER_COLUMN_SALES_ORG);
                                    if (salesOrgFilter) {
                                        salesOrgFilter.value = salesOrg;
                                    } else {
                                        currentFilters.push({ id: CREATE_ORDER_COLUMN_SALES_ORG, value: salesOrg });
                                    }
                                    return currentFilters;
                                })
                            }
                            label={resources.createOrderSalesOrgLabel}
                        ></Dropdown>
                    </fieldset>
                </div>
                <div className='col-12 col-lg-4'>
                    <fieldset className='msc-form__group'>
                        <Dropdown
                            disabled={filterDisabled}
                            id={CREATE_ORDER_COLUMN_BUSINESS_UNIT}
                            value={(columnFilters.find(filter => filter.id === CREATE_ORDER_COLUMN_BUSINESS_UNIT)?.value as string) ?? ''}
                            options={businessUnitOptions}
                            resources={resources}
                            onChange={(businessUnit: string) => {
                                setColumnFilters(prev => {
                                    const currentFilters = prev.slice();
                                    const businessUnitFilter = currentFilters.find(
                                        filter => filter.id === CREATE_ORDER_COLUMN_BUSINESS_UNIT
                                    );
                                    if (businessUnitFilter) {
                                        businessUnitFilter.value = businessUnit;
                                    } else {
                                        currentFilters.push({ id: CREATE_ORDER_COLUMN_BUSINESS_UNIT, value: businessUnit });
                                    }
                                    return currentFilters;
                                });
                            }}
                            label={resources.createOrderBusinessUnitLabel}
                        ></Dropdown>
                    </fieldset>
                </div>
                <div className='col-12 col-lg-4'>
                    {incotermOptions && incotermOptions.length > 0 && (
                        <fieldset className='msc-form__group'>
                            <Dropdown
                                disabled={filterDisabled}
                                id={CREATE_ORDER_COLUMN_INCOTERM}
                                value={(columnFilters.find(filter => filter.id === CREATE_ORDER_COLUMN_INCOTERM)?.value as string) ?? ''}
                                options={incotermOptions}
                                resources={resources}
                                onChange={(incoterm: string) => {
                                    setColumnFilters(prev => {
                                        const currentFilters = prev.slice();
                                        const incotermFilter = currentFilters.find(filter => filter.id === CREATE_ORDER_COLUMN_INCOTERM);
                                        if (incotermFilter) {
                                            incotermFilter.value = incoterm;
                                        } else {
                                            currentFilters.push({ id: CREATE_ORDER_COLUMN_INCOTERM, value: incoterm });
                                        }
                                        return currentFilters;
                                    });
                                }}
                                label={resources.createOrderIncoterms1Label}
                            ></Dropdown>
                        </fieldset>
                    )}
                </div>
            </div>
            {!isColumnFilterValid && alertVisible && (
                <div className='row'>
                    <div className='col-12'>
                        <Alert
                            message={resources.createOrderFilterNotValid}
                            type='info'
                            iconSize={1}
                            closable
                            onClose={() => setAlertVisible(false)}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
